// extracted by mini-css-extract-plugin
module.exports = {"filtersBlock":"styles_filtersBlock__7EypO","filters":"styles_filters__1VPKu"};